import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Label from "../components/Label";
// material
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  Grid,
  Checkbox,
  FormControlLabel,
  Icon,
  FormControl,
  FormLabel,
  FormGroup,
  Switch,
  CircularProgress
} from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import { notification } from "src/utils/messages";
import { deleteStaff, updateStaffDetails, updateStaffStatus } from "src/api/commonapi";
import Page from "../components/Page";
import { insertStaff } from "src/api/commonapi";
import { fetchstaffbypid } from "src/utils/common";
import { CancelRounded, CheckCircleRounded, EditSharp, DeleteSharp } from "@mui/icons-material";
import Deletemodal from "./DeleteModal";
import { CSVLink } from "react-csv";
import CustomLoader from "src/components/CustomLoader";
export default function Subadmin() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [formdata, setformdata] = useState({
    // sales_p: 0,
    // account_p: 0,
    // management_p: 0,
    is_subadmin: 1,
    city_id: loginUser.city_id,
    p_user_id: loginUser.u_id
  });
  const [staffdata, setstaffdata] = useState([]);

  const getstafflist = async () => {
    setIsLoading(true);
    setstaffdata(await fetchstaffbypid(loginUser.u_id));
    setIsLoading(false);
  };

  useEffect(async () => {
    await getstafflist();
  }, []);

  const onChangeFunction = (e) => {
    setformdata({ ...formdata, [e.target.name]: e.target.value });
  };

  const changestatus = async (u_id, u_status) => {
    let fdata = new FormData();
    fdata.append("u_id", u_id);
    fdata.append("u_status", u_status);

    setIsLoading(true);
    const resp = await updateStaffStatus(fdata);
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    getstafflist();
  };

  const deletestaff = async (u_id) => {
    let fdata = new FormData();
    fdata.append("u_id", u_id);

    setIsLoading(true);
    const resp = await deleteStaff(fdata);
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      getstafflist();
      setDvisible({ mval: false, id: 0 });
    }
  };

  const formattedCSVData = staffdata.map((row, index) => ({
    u_id: index + 1,
    name: row.name,
    email: row.email
    // sales_permission: row.sales_permission,
    // account_permission: row.account_permission,
    // management_permission: row.management_permission
  }));

  const expo_columns = [
    { label: "No", key: "u_id" },
    { label: "Name", key: "name" },
    { label: "Email", key: "email" }
    // { label: "Sales Permission", key: "sales_permission" },
    // { label: "Account Permission", key: "account_permission" },
    // { label: "Management", key: "management_permission" }
  ];

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row, index) => index + 1,
      sortable: true,
      width: "100px"
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row.name
    },
    {
      name: "Email",
      wrap: true,
      selector: (row) => row.email
    },
    // {
    //   name: "Sales Permision",
    //   wrap: true,
    //   cell: (row) => (
    //     <>
    //       <Icon>
    //         {row.sales_p == 1 ? (
    //           <CheckCircleRounded color="success" />
    //         ) : (
    //           <CancelRounded color="error" />
    //         )}
    //       </Icon>
    //     </>
    //   )
    // },
    // loginUser.u_type == 3 && {
    //   name: "Account Permission",
    //   wrap: true,
    //   cell: (row) => (
    //     <>
    //       <Icon>
    //         {row.account_p == 1 ? (
    //           <CheckCircleRounded color="success" />
    //         ) : (
    //           <CancelRounded color="error" />
    //         )}
    //       </Icon>
    //     </>
    //   )
    // },
    // {
    //   name: "Management",
    //   wrap: true,
    //   cell: (row) => (
    //     <>
    //       <Icon>
    //         {row.management_p == 1 ? (
    //           <CheckCircleRounded color="success" />
    //         ) : (
    //           <CancelRounded color="error" />
    //         )}
    //       </Icon>
    //     </>
    //   )
    // },
    {
      name: "Status",
      wrap: true,
      selector: (row) => (
        <>
          {row.u_status == 0 ? (
            <>
              <div style={{ margin: "10px 0" }}>
                <Label
                  variant="ghost"
                  color="success"
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    fontSize: "16px"
                  }}
                >
                  Active
                </Label>

                <Button
                  variant="contained"
                  onClick={() => {
                    changestatus(row.u_id, 1);
                  }}
                  style={{ background: "#ff4842" }}
                  disabled={isLoading}
                  startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                >
                  Deactive
                </Button>
              </div>
            </>
          ) : (
            <>
              <div style={{ margin: "10px 0" }}>
                <Label
                  variant="ghost"
                  color="error"
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    fontSize: "14px"
                  }}
                >
                  Deactive
                </Label>

                <Button
                  variant="contained"
                  onClick={() => {
                    changestatus(row.u_id, 0);
                  }}
                  disabled={isLoading}
                  startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                >
                  Active
                </Button>
              </div>
            </>
          )}
        </>
      )
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <>
          <a
            onClick={() => {
              setStep(2);
              setformdata(row);
            }}
          >
            <Tooltip title="Edit">
              <IconButton>
                <EditSharp color="warning" />
              </IconButton>
            </Tooltip>
          </a>

          <a
            onClick={() => {
              setDvisible({ mval: true, id: row.u_id });
            }}
          >
            <Tooltip title="Delete">
              <IconButton>
                <DeleteSharp color="error" />
              </IconButton>
            </Tooltip>
          </a>
        </>
      )
    }
  ].filter((f) => f != false);

  const submitformdata = async () => {
    if (
      formdata.name == undefined ||
      formdata.name == "" ||
      formdata.email == undefined ||
      formdata.email == "" ||
      formdata.mobile == undefined ||
      formdata.mobile == "" ||
      formdata.password == undefined ||
      formdata.password == ""
    ) {
      let notify = notification({
        type: "error",
        message: "Please Fill All Fields"
      });
      notify();
    }
    // else if (formdata.sales_p == 0 && formdata.account_p == 0 && formdata.management_p == 0) {
    //   let notify = notification({
    //     type: "error",
    //     message: "Please select atleast one permission"
    //   });
    //   notify();
    // }
    else {
      setLoading(true);
      let resp;
      if (step == 1) {
        resp = await insertStaff(JSON.stringify(formdata));
      }
      if (step == 2) {
        resp = await updateStaffDetails(JSON.stringify(formdata));
      }
      if (resp.status == 1) {
        setStep(0);
        setformdata({
          // sales_p: 0,
          // account_p: 0,
          // management_p: 0,
          is_subadmin: 1,
          city_id: loginUser.city_id,
          p_user_id: loginUser.u_id
        });
        getstafflist();
      }
      setLoading(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
    }
  };
  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={deletestaff} />
      <Page title="Subadmin | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Subadmin
            </Typography>
          </Stack>
          {step != 0 ? (
            <>
              <Button
                onClick={() => {
                  setStep(0);
                  setformdata({
                    // sales_p: 0,
                    // account_p: 0,
                    // management_p: 0,
                    is_subadmin: 1,
                    city_id: loginUser.city_id,
                    p_user_id: loginUser.u_id
                  });
                }}
                style={{ marginBottom: "15px" }}
                variant="contained"
              >
                Back
              </Button>
              <Card
                style={{
                  padding: "25px",
                  paddingBottom: "25px",
                  marginBottom: "25px"
                }}
              >
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Name"
                          name="name"
                          value={formdata?.name}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Contact No"
                          name="mobile"
                          value={formdata?.mobile}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="email"
                          label="Email Id"
                          name="email"
                          value={formdata?.email}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Password"
                          name="password"
                          value={formdata?.password}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    {/* <Grid item xs={6}>
                      <Stack>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Is Subadmin</FormLabel>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  name="is_subadmin"
                                  checked={formdata.is_subadmin == 0 ? false : true}
                                  onChange={(e) => {
                                    setformdata({
                                      ...formdata,
                                      sales_p: 0,
                                      account_p: 0,
                                      management_p: 0,
                                      [e.target.name]: e.target.checked == true ? 1 : 0
                                    });
                                  }}
                                />
                              }
                            />
                          </FormGroup>
                        </FormControl>
                      </Stack>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        label="Sales permission"
                        control={
                          <Checkbox
                            checked={formdata?.sales_p == 1 ? true : false}
                            onChange={(e) => {
                              setformdata({
                                ...formdata,
                                sales_p: e.target.checked ? 1 : 0
                              });
                            }}
                          />
                        }
                      />
                      {loginUser.u_type == 3 && (
                        <>
                          <FormControlLabel
                            label="Account permission"
                            control={
                              <Checkbox
                                checked={formdata?.account_p == 1 ? true : false}
                                onChange={(e) => {
                                  setformdata({
                                    ...formdata,
                                    account_p: e.target.checked ? 1 : 0
                                  });
                                }}
                              />
                            }
                          />
                        </>
                      )}
                      <FormControlLabel
                        label="Management"
                        control={
                          <Checkbox
                            checked={formdata?.management_p == 1 ? true : false}
                            onChange={(e) => {
                              setformdata({
                                ...formdata,
                                management_p: e.target.checked ? 1 : 0
                              });
                            }}
                          />
                        }
                      />
                    </Grid> */}
                  </Grid>
                </Stack>

                <Button
                  style={{ marginTop: "15px" }}
                  variant="contained"
                  onClick={submitformdata}
                  disabled={loading}
                  startIcon={loading && <CircularProgress size={20} color="inherit" />}
                >
                  Save
                </Button>
              </Card>
            </>
          ) : (
            <>
              <Button
                onClick={() => {
                  setStep(1);
                }}
                style={{ marginBottom: "15px" }}
                variant="contained"
              >
                Add Subadmin
              </Button>
              <Card>
                {staffdata && (
                  <>
                    <Button className="btn btn-export">
                      <CSVLink
                        data={formattedCSVData}
                        headers={expo_columns}
                        filename={"SubadminList.csv"}
                        className="btn btn-primary test"
                        target="_blank"
                      >
                        Export CSV
                      </CSVLink>
                    </Button>
                    <DataTable
                      title="Subadmin Record"
                      filter
                      pagination
                      highlightOnHover
                      columns={columns}
                      data={staffdata}
                      progressPending={isLoading}
                      progressComponent={<CustomLoader />}
                    />
                  </>
                )}
              </Card>
            </>
          )}
        </Container>
      </Page>
    </>
  );
}
